import { MutationTree } from 'vuex';
import moment from 'moment';
import { IDocumentState } from '@signing-page/documents/store/document.types';
import { IDocument } from '@signing-page/documents/types/document';
import { EDocumentStatus } from '@signing-page/documents/types/enums/document-status';
import { IDocumentAttachment } from '@lib-shared/types/document-attachment';
import { ERecipientStatus } from '@lib-shared/recipients/types/enums/recipient-status';
import { IRecipient } from '@signing-page/documents/types/recipient';
import { IDocumentRevision } from '@signing-page/documents/types/document-revision';
import { EDocumentMutation } from '@signing-page/documents/store/document.constants';
import { IEditorRecipientInput } from '@lib-shared/types/editor-recipient-input';
export const mutations: MutationTree<IDocumentState> = {
  [EDocumentMutation.SetLoading](state: IDocumentState, loading: boolean) {
    state.isLoading = loading;
  },
  [EDocumentMutation.SetRevisionsLoading](state: IDocumentState, loading: boolean) {
    state.revisionsIsLoading = loading;
  },
  [EDocumentMutation.SetRevisionsViewedLoading](state: IDocumentState, loading: boolean) {
    state.revisionsViewedLoading = loading;
  },
  [EDocumentMutation.SetEditorRecipientInput](
    state: IDocumentState,
    editorRecipientInput: IEditorRecipientInput[]
  ) {
    state.editorRecipientInput = editorRecipientInput;
  },
  [EDocumentMutation.SetButtonLoading](state: IDocumentState, loading: boolean) {
    state.isButtonLoading = loading;
  },
  [EDocumentMutation.SetForwarded](state: IDocumentState, forwarded: boolean) {
    state.forwarded = forwarded;
  },
  [EDocumentMutation.SetDocument](state: IDocumentState, document: IDocument) {
    state.document = document;
  },
  [EDocumentMutation.SetDocumentRevisions](
    state: IDocumentState,
    documentRevisions: IDocumentRevision[]
  ) {
    state.document.documentRevisions = documentRevisions;
  },
  [EDocumentMutation.SetPdfUrl](state: IDocumentState, pdfUrl: string) {
    state.pdfUrl = pdfUrl;
  },
  [EDocumentMutation.SetFocusedRequiredId](state: IDocumentState, focusedRequiredId: string) {
    state.focusedRequiredId = focusedRequiredId;
  },
  [EDocumentMutation.SetDocumentStatus](state: IDocumentState, status: EDocumentStatus) {
    state.document.status = status;
  },
  [EDocumentMutation.SetDocumentSignedDate](state: IDocumentState, date: string) {
    state.document.signDate = date;
  },
  [EDocumentMutation.UpdateRecipients](state: IDocumentState, recipients: IRecipient[]) {
    state.document.recipients = recipients;
  },
  [EDocumentMutation.SetRecipientStatus](
    state: IDocumentState,
    { recipientId, status }: { recipientId: string; status: ERecipientStatus }
  ) {
    const recipientsUpdated: IRecipient[] = state.document.recipients.map(recipient => {
      return recipient.id === recipientId ? { ...recipient, status } : recipient;
    });
    state.document = { ...state.document, recipients: recipientsUpdated };
  },
  [EDocumentMutation.SetDocumentAttachments](
    state: IDocumentState,
    attachments: IDocumentAttachment[]
  ) {
    state.document.documentAttachments = attachments;
  },
  [EDocumentMutation.SetAttachmentView](state: IDocumentState, id: string) {
    const attachments: IDocumentAttachment[] = [...state.document.documentAttachments];
    const index: number = attachments.findIndex((item: IDocumentAttachment) => item.id === id);
    attachments[index].lastView = moment().toISOString();
    state.document.documentAttachments = attachments;
  },
  [EDocumentMutation.SetUploadingAttachment](state: IDocumentState, attachmentId: string) {
    state.uploadingAttachmentIds.push(attachmentId);
  },
  [EDocumentMutation.RemoveUploadingAttachment](state: IDocumentState, attachmentId: string) {
    const newIds: string[] = state.uploadingAttachmentIds.filter(
      (id: string) => id !== attachmentId
    );
    state.uploadingAttachmentIds = newIds;
  },
  [EDocumentMutation.SetError](state: IDocumentState, error: boolean) {
    state.error = error;
  },
  [EDocumentMutation.SetIsDownloading](state: IDocumentState, isDownloading: boolean) {
    state.isDownloading = isDownloading;
  },
};
